/**
 * Created by Bob.Gear on 11/03/14.
 * 
 * 30 May 2024 - disaster! polluting the prototype like this has
 * prevented the upgraded uiRouter from working properly
 * https://github.com/ui-router/core/issues/840
 * (I feel like a real idiot for not being able to find this for 
 * myyself. This code is so old that I've forgotten how most of it
 * works)
 */

// Array.prototype.objectPresent = function (item, comparisonField) {
//   var len = this.length;

//   for (var i = 0; i < len; i++) {
//     if (this[i][comparisonField] == item[comparisonField]) {
//       return true;
//     }
//   }

//   return false;
// }


//------------------------------------------------------------------------
//  operatorsFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('operatorsFilterController', ['$scope', '$http', '$timeout',
      function ($scope, $http, $timeout) {
        $scope.componentName = "operatorsFilter";

        var objectPresent = function (array, item, comparisonField) {
          var len = array.length;

          for (var i = 0; i < len; i++) {
            if (array[i][comparisonField] == item[comparisonField]) {
              return true;
            }
          }

          return false;
        };

        $scope.availableOperators = [];

        $scope.getOperators = function(inputValue) {
          if (!inputValue) {
            $scope.availableOperators.length = 0;
            return;
          }


          // var q = { operatorName: inputValue};

          return $http.get('/api/operatorname', {
            params: {
              limit: 75,
              operatorname: inputValue
            }
          }).then(function(res) {
            $scope.availableOperators = res.data.filter(function(item) {
              if (!$scope.selectedOperators) return true; // selected operators do not yet exist, so  select all

              //if ($scope.selectedOperators.objectPresent(item, "companyID")) {
              if (objectPresent($scope.selectedOperators, item, "companyID")) {
                // object has already been selected; false omits it from the returned list
                return false;
              } else {
                return true;
              }
            });

          });
        };



        $scope.addCheckedItems = function () {
          if (!$scope.selectedOperators) $scope.selectedOperators = [];

          // Add the chosen items to the model by copying fom selectedContractors
          // - they get automatically selected because of the 'initially selected clause
          Array.prototype.push.apply($scope.selectedOperators, $scope.candidateOperators);

          $scope.candidateOperators.length = 0;
          $scope.availableOperators.length = 0;
        };


        $scope.initialiseSelectedOperators = function () {
          if(!$scope.criteria.selectedOperators) return;

          // initialise the selectedOperators by copying from the model
          if (!$scope.selectedOperators) $scope.selectedOperators = [];
          Array.prototype.push.apply($scope.selectedOperators, $scope.criteria.selectedOperators);
        };

          $scope.candidateOperators = [];

          if ($scope.criteria.operatorOnly == null)
        $scope.criteria.operatorOnly = true;

        $scope.resetFilter = function () {
          $scope.candidateOperators.length = 0;
          $scope.availableOperators.length = 0;

          // fully remove the selected operators key; it is no longer needed
          $scope.criteria.selectedOperators = null;
          delete $scope.criteria.selectedOperators;

          $scope.criteria.operatorOnly = null;
        };

        $scope.removeOperatorsFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#operatorsFilter");
        };

        $scope.$watch("candidateOperators.length", function () {
          if (!$scope.candidateOperators) return;

          $scope.candidateOperatorCount = $scope.candidateOperators.length;
          $scope.candidateOperatorPlural = ($scope.candidateOperatorCount === 1) ? "" : "s";
        });

        $scope.$watch("criteria.selectedOperators.length", function () {
          if (!$scope.criteria.selectedOperators) return;

          $scope.selectedOperatorCount = $scope.criteria.selectedOperators.length;
          $scope.selectedOperatorPlural = ($scope.selectedOperatorCount === 1) ? "" : "s";
        });


        // when the filter starts up, move entries from the model to selected operators
        $scope.initialiseSelectedOperators();
      }])
    .directive('operatorsFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/operatorsFilter.tmpl.html",

            link: function ($scope, iElement, iAttrs) {

            },

          controller: 'operatorsFilterController'
        };
      }]);
//------------------------------------------------------------------------
